import { render, staticRenderFns } from "./PolPendingRI.vue?vue&type=template&id=66554170&"
import script from "./PolPendingRI.vue?vue&type=script&lang=js&"
export * from "./PolPendingRI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports